import React, { useMemo } from 'react'
import ExperiencesPageCarousel from './ExperiencesPageCarousel'
import useOrderExperienceCarousels from './useOrderExperienceCarousels'
import { take } from 'lib/array/arrayUtils'
import { getMonthShortName, isSameMonth } from 'lib/datetime/dateUtils'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import moment from 'moment'

function getDateFormat(start: string, end: string) {
  const startDate = new Date(start)
  const endDate = new Date(end)
  let format = startDate.getDate().toString()
  if (!isSameMonth(startDate, endDate)) {
    format += ` ${getMonthShortName(startDate)}`
  }
  format += ` - ${endDate.getDate()} ${getMonthShortName(endDate)}`

  return format
}

function ExperiencesPageUpcomingOrderCarousels() {
  const carouselData = useOrderExperienceCarousels()
  const orderCarousels = useMemo(() => {
    return take(carouselData, 2)
  }, [carouselData])

  return <>
    {orderCarousels.map(carousel => <ExperiencesPageCarousel
      key={carousel.place.id}
      title={`Things to do when you're in ${carousel.place.name}`}
      subtitle={`${getDateFormat(carousel.dates.checkIn, carousel.dates.checkOut)} • Within 50km of ${carousel.propertyName}`}
      place={carousel.place}
      latitude={carousel.coords.latitude}
      longitude={carousel.coords.longitude}
      checkIn={moment(carousel.dates.checkIn).subtract(7, 'days').format(ISO_DATE_FORMAT)}
      checkOut={moment(carousel.dates.checkOut).add(7, 'days').format(ISO_DATE_FORMAT)}
    />)}
  </>
}

export default React.memo(ExperiencesPageUpcomingOrderCarousels)
